<template>
  <main class="w-full h-full mb-16">
    <Loader :loader="isLoading" />
    <section v-if="!isLoading">
      <img
        src="@/assets/images/empty-course-forum.svg"
        alt="empty courses"
        v-if="!query.name && totalForums == 0"
        class="w-[657px] mx-auto flex mt-32"
      />

      <section v-else>
        <span class="p-input-icon-right w-[41vw] w-max-[657px]">
          <InputText
            type="text"
            v-model="inputCourseName"
            :placeholder="$t('course.search')"
            class="p-inputtext-sm"
            @keyup.enter="filterCourseByName()"
          />
          <i v-if="!inputCourseName" class="pi pi-search" />
          <i v-else class="cursor-pointer pi pi-times" @click="clearFilter"></i>
        </span>

        <h5 class="my-6 text-[#050505]">
          {{ formatSearchText() }}
        </h5>

        <div
          v-if="query.name && totalForums == 0"
          class="flex flex-col items-center justify-center"
        >
          <img
            src="@/assets/images/not-found-course-forum.svg"
            alt="not found course"
            class="w-[657px] my-auto flex mt-32"
          />
          <button
            class="flex justify-center mt-6 items-center btn-outline rounded px-2 py-[6px]"
            @click="clearFilter"
          >
            {{
              $t("labels.generic", {
                pt: "Limpar pesquisa",
                en: "Clear search",
              })
            }}
          </button>
        </div>
        <div v-else class="flex flex-col gap-2">
          <ForumCard
            v-for="course in courses"
            :course="course"
            :key="course.id"
          />
          <Paginator
            :totalRecords="totalForums"
            :rows="numberofForumsPerPage"
            :value="courses"
            :first="getFirstItemIndexActualPage()"
            @page="onPaginate"
            :pageLinkSize="3"
            v-if="totalForums > numberofForumsPerPage"
            class="mb-16 md:w-full w-fit md:flex md:right-0 md:justify-end custom-paginator-forum"
          ></Paginator>
        </div>
      </section>
    </section>
  </main>
</template>
<script lang="ts">
import { Course } from "@/models/courses.model";
import { defineComponent, defineAsyncComponent } from "vue";
import { ForumService } from "../forum.service";
import { QueryParams } from "@/models/query-params.model";
import { PageState } from "primevue/paginator";

const ForumCard = defineAsyncComponent(
  () => import("./CardForum/card-forum.vue")
);

export default defineComponent({
  name: "list-forum",
  components: {
    ForumCard,
  },
  data() {
    return {
      courses: [] as Array<Course>,
      query: new QueryParams(),
      numberofForumsPerPage: 0,
      totalForums: 0,
      isLoading: true,
      inputCourseName: "",
    };
  },
  methods: {
    getAllCourses(): void {
      this.service.courses.pipe().subscribe({
        next: (response) => {
          this.courses = response.content;
          this.totalForums = response.total;
          this.numberofForumsPerPage = response.size;
          if (response.content !== undefined) {
            this.isLoading = false;
          }
        },
      });
      this.service.getCourses(this.query);
    },
    filterCourseByName(): void {
      this.query.name = this.inputCourseName;
      this.query.page = 0;
      this.$router.push({
        name: "listForums",
        query: {
          page: this.query.page,
          size: this.query.size,
          name: this.query.name,
        },
      });

      this.getAllCourses();
    },
    clearFilter(): void {
      this.query.name = "";
      this.inputCourseName = "";
      this.$router.push({
        name: "listForums",
        query: { page: this.query.page, size: this.query.size },
      });
      this.getAllCourses();
      this.isLoading = true;
    },
    getFirstItemIndexActualPage(): number | undefined {
      if (this.$route.query.page) {
        return (
          Number(this.$route.query.page) * Number(this.numberofForumsPerPage) +
          1
        );
      }
    },
    onPaginate(event: PageState): void {
      this.query.page = event.page;
      this.$router.push({
        name: "listForums",
        query: { page: this.query.page, size: this.query.size },
      });
      this.getAllCourses();
    },
    formatSearchText(): string {
      if (this.query.name && this.totalForums !== 1) {
        return (
          this.totalForums +
          " " +
          `${
            this.$t("labels.generic", {
              pt: "cursos sobre ",
              en: "courses about ",
            }) +
            '"' +
            this.query.name +
            '"'
          }`
        );
      } else if (this.query.name && this.totalForums === 1) {
        return (
          this.totalForums +
          " " +
          `${
            this.$t("labels.generic", {
              pt: "curso sobre ",
              en: "course about ",
            }) +
            '"' +
            this.query.name +
            '"'
          }`
        );
      } else if (this.totalForums !== 1) {
        return (
          this.totalForums +
          " " +
          `${this.$t("labels.generic", {
            pt: "cursos listados",
            en: "courses listed",
          })}`
        );
      } else {
        return (
          this.totalForums +
          " " +
          this.$t("labels.generic", {
            pt: "curso listado",
            en: "course listed",
          })
        );
      }
    },
  },
  computed: {
    service(): ForumService {
      return new ForumService();
    },
  },
  mounted() {
    this.getAllCourses();
    this.$router.push({
      name: "listForums",
      query: {
        page: this.query.page | 0,
        size: this.numberofForumsPerPage | 10,
      },
    });
  },
});
</script>
